import React from 'react';
import MenuBanner from './MenuBanner';
import MenuContainer1 from './MenuContainer1';
import MenuLastContainer from './MenuLastContainer';
import MenuContainer2 from './MenuContainer2';

const MenusPage = () => (
	<div>
		<MenuBanner />
		<MenuContainer1 />
		<MenuContainer2 />
		<MenuLastContainer />
	</div>
);

export default MenusPage;
